import { supabase } from '../supabaseClient';
import { rutaEnBucket, type BucketArchivos } from './ruta-bucket';

// Archivos de los buckets sso-documents, safety-sheets y layout-files (§17 ítem
// 72, Fase 0 bloque 10). Los tres pasan a privados: para ver o descargar se
// firma una URL de corta duración en el momento del clic.
//
// Las columnas (file_url, pdf_url, sds_url, layout_url) guardan hoy la URL
// pública que devolvía getPublicUrl(); después de M30 guardarán la ruta. Mientras
// convivan, rutaEnBucket() (lib/ruta-bucket.ts) acepta las dos.
export { rutaEnBucket, type BucketArchivos } from './ruta-bucket';

export const SEGUNDOS_URL_FIRMADA = 120;

const MENSAJE_ERROR = 'No se pudo abrir el archivo. Intenta de nuevo; si continúa, recarga la página.';

async function firmar(bucket: BucketArchivos, ruta: string, descargar?: string | boolean): Promise<string | null> {
  const { data, error } = await supabase.storage
    .from(bucket)
    .createSignedUrl(ruta, SEGUNDOS_URL_FIRMADA, descargar ? { download: descargar } : undefined);
  if (error || !data?.signedUrl) {
    console.error(`No se pudo firmar la URL de ${bucket}:`, error ?? 'sin URL');
    return null;
  }
  return data.signedUrl;
}

/**
 * Abre el archivo en una pestaña nueva con una URL firmada.
 *
 * La pestaña se abre ANTES del primer await (en el mismo clic): Safari y iOS
 * bloquean window.open después de una espera. Llamar directo desde onClick.
 */
export async function abrirArchivo(bucket: BucketArchivos, valor: string | null | undefined): Promise<boolean> {
  const ruta = rutaEnBucket(bucket, valor);
  if (!ruta) {
    alert(MENSAJE_ERROR);
    return false;
  }
  const ventana = window.open('', '_blank');
  if (ventana) ventana.opener = null;
  const url = await firmar(bucket, ruta);
  if (!url) {
    ventana?.close();
    alert(MENSAJE_ERROR);
    return false;
  }
  if (ventana) ventana.location.href = url;
  else window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}

/**
 * Descarga el archivo con una URL firmada que pide Content-Disposition:
 * attachment (con el nombre dado, si hay). Una descarga no es una ventana
 * emergente, así que puede ir después del await.
 */
export async function descargarArchivo(bucket: BucketArchivos, valor: string | null | undefined, nombre?: string): Promise<boolean> {
  const ruta = rutaEnBucket(bucket, valor);
  const url = ruta ? await firmar(bucket, ruta, nombre || true) : null;
  if (!url) {
    alert(MENSAJE_ERROR);
    return false;
  }
  const a = document.createElement('a');
  a.href = url;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  return true;
}
